import type { SVGProps } from "react";

/**
 * writing
 * @category Edit
 */
export default function IconWriting(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M8.25 12.2499H5.75C4.64543 12.2499 3.75 13.1454 3.75 14.2499C3.75 15.3545 4.64543 16.2499 5.75 16.2499H16.25C17.3546 16.2499 18.25 17.1454 18.25 18.2499C18.25 19.3545 17.3546 20.2499 16.25 20.2499H11.75M11.75 12.2499H13.9216C14.452 12.2499 14.9607 12.0392 15.3358 11.6642L19.8358 7.16416C20.6168 6.38311 20.6168 5.11678 19.8358 4.33573L19.6642 4.16416C18.8832 3.38311 17.6168 3.38311 16.8358 4.16416L12.3358 8.66416C11.9607 9.03923 11.75 9.54794 11.75 10.0784V12.2499Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
